import React from 'react';
import {
	Table as BootstrapTable,
	Button,
	FormControl,
	Col,
	Row,
	ControlLabel,
	InputGroup
} from 'react-bootstrap'
import Dropzone from "react-dropzone";

const moment = require('moment')

import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import ic_calendar from '../assets/images/ic_calendar.svg';
import ic_add_image from '../assets/images/ic_add_image.svg';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

const Parse = require("parse");

const CRUDForm = props => {

	let {
		schema,
		formType,
		selectedData,
		loadOptions,
		selectedDataPointer,
		selectedDataBoolean,
		selectedParseFile,
		stateSetter
	} = props;

	const exclude = ['OBJECTID', 'CREATEDAT', 'UPDATEDAT']

	console.log('==========formType', formType)

	const isUndefined = (obj) => typeof obj === 'undefined'
		? true
		: false

	const getValue = (column) => isUndefined(selectedData.get(column))
		? ''
		: selectedData.get(column)

	const getDateValue = (column) => isUndefined(selectedData.get(column))
		? undefined
		: moment(selectedData.get(column))

	const margins = {
		marginBottom: '10px',
		marginTop: '10px'
	}

	const setValue = (column, value) => selectedData.set(column, value)
	const setDateValue = (column, value) => selectedData.set(column, moment(value).toDate())

	const generateFormType = ({
		columnName,
		columnLabel,
		type,
		format,
		targetClass,
		displayColumn
	}) => {
		if (exclude.indexOf(columnName.toUpperCase()) != -1) {
			return ''
		}

		switch (type.toUpperCase()) {
			case 'STRING':
				return (
					<Col md={6} key={columnName} style={margins}>
						<ControlLabel>
							{isUndefined(columnLabel)
								? columnName.toUpperCase()
								: columnLabel.toUpperCase()}
						</ControlLabel>
						<FormControl type="text" defaultValue={getValue(columnName)} onInput={(e) => {
							if (e.target.value !== "") {
								setValue(columnName, e.target.value);
							} else {
								selectedData.unset(columnName);
							}
						}} placeholder={'ENTER ' + (isUndefined(columnLabel)
							? columnName.toUpperCase()
							: columnLabel.toUpperCase()) + '...'} />
					</Col>
				);
			case 'DATE':
				return (
					<Col md={6} key={columnName} style={margins}>
						<ControlLabel>
							{isUndefined(columnLabel)
								? columnName.toUpperCase()
								: columnLabel.toUpperCase()}
						</ControlLabel>
						<InputGroup>
							<DateTime className="form-control" disableOnClickOutside={true} value={getDateValue(columnName)} onChange={(e) => setDateValue(columnName, e)} />
							<InputGroup.Button >
								<Button className="btn btn-primary" style={{
									paddingTop: '0',
									paddingBottom: '0'
								}}>
									<img src={`${ic_calendar}`} height="32px" />
								</Button>
							</InputGroup.Button>
						</InputGroup>

					</Col>
				);
			case 'POINTER':
				return (
					<Col md={6} key={columnName} style={margins}>
						<ControlLabel>
							{isUndefined(columnLabel)
								? columnName.toUpperCase()
								: columnLabel.toUpperCase()}
						</ControlLabel>
						<Select.Async autoload={false} id={columnName} value={(selectedDataPointer)
							? selectedDataPointer[columnName]
							: null} onChange={(val) => {
								let pointer = {
									...selectedDataPointer
								}
								if (val != null) {
									var PointerClass = Parse.Object.extend(targetClass),
										pointerClass = new PointerClass();
									pointerClass.id = val.value;
									pointer[columnName] = val;
									stateSetter([
										{
											state: 'selectedDataPointer',
											value: pointer
										}
									]);
									setValue(columnName, pointerClass);
								} else {
									pointer[columnName] = val;
									stateSetter([
										{
											state: 'selectedDataPointer',
											value: pointer
										}
									]);
									selectedData.unset(columnName);
								}
							}} loadOptions={(input, cb) => loadOptions(input, cb, targetClass, displayColumn)} />
					</Col>
				);
			case 'NUMBER':
				return (
					<Col md={6} key={columnName} style={margins}>
						<ControlLabel>
							{isUndefined(columnLabel)
								? columnName.toUpperCase()
								: columnLabel.toUpperCase()}
						</ControlLabel>
						<FormControl type="number" min={0} defaultValue={getValue(columnName)} onInput={(e) => {
							let target = e.target.value;
							if (target !== "") {
								let value = parseFloat(target)
								if (value < 0) {
									value = 0
									target = 0;
								}
								console.log({ value })
								setValue(columnName, value)
							} else {
								selectedData.unset(columnName);
							}
						}} placeholder={'ENTER ' + (isUndefined(columnLabel)
							? columnName.toUpperCase()
							: columnLabel.toUpperCase()) + '...'} />
					</Col>
				);
			case 'BOOLEAN':
				let booleanValue = getValue(columnName);
				return (
					<Col md={6} key={columnName} style={margins}>
						<ControlLabel>
							{isUndefined(columnLabel)
								? columnName.toUpperCase()
								: columnLabel.toUpperCase()}
						</ControlLabel>
						<Select id={columnName} value={(selectedDataBoolean)
							? selectedDataBoolean[columnName]
							: null} options={[
								{
									value: 'true',
									label: 'TRUE'
								}, {
									value: 'false',
									label: 'FALSE'
								}
							]} onChange={(val) => {
								let boolean = {
									...selectedDataBoolean
								}
								if (val != null) {

									boolean[columnName] = val;
									stateSetter([
										{
											state: 'selectedDataBoolean',
											value: boolean
										}
									]);
									setValue(columnName, val.value.toUpperCase() === 'TRUE'
										? true
										: false);
								} else {
									boolean[columnName] = val;
									stateSetter([
										{
											state: 'selectedDataBoolean',
											value: boolean
										}
									]);
									selectedData.unset(columnName);
								}
							}} />
					</Col>
				);
			case 'PARSEFILE':
				let value = selectedParseFile[columnName];
				console.log('selectedData', value);
				let picture = (isUndefined(value)
					? `${ic_add_image}`
					: isUndefined(value.preview)
						? value.url()
						: value.preview)

				let stylePicture = (isUndefined(value)
					? {
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						margin: 'auto',
						width: '100px',
						height: '100%'
					}
					: {
						maxWidth: '100%',
						maxHeight: '100%'
					})
				let dropStyle = (isUndefined(value)
					? {
						display: "inline-block",
						verticalAlign: "top"
					}
					: {
						display: "table-cell",
						verticalAlign: "middle"
					})
				let isHideX = (isUndefined(value)
					? {
						display: 'none'
					}
					: '')
				// let booleanValue = getValue(columnName);
				return (
					<Col md={6} key={columnName} style={margins}>
						<ControlLabel>
							{isUndefined(columnLabel)
								? columnName.toUpperCase()
								: columnLabel.toUpperCase()}
						</ControlLabel>
						<Col md={12}>
							<div style={{
								position: 'absolute',
								width: '30px',
								height: '30px',
								background: 'white',
								paddingTop: '4px',
								top: '-10px',
								right: '5px',
								textAlign: 'center',
								borderRadius: '50px',
								fontWeight: '600',
								cursor: 'pointer',
								...isHideX
							}} onClick={() => {
								let file = {
									...selectedParseFile
								};
								file[columnName] = undefined;
								stateSetter([
									{
										state: 'selectedParseFile',
										value: file
									}
								]);
								selectedData.unset(columnName);
							}}>x</div>
							<Dropzone accept="image/*" onDrop={(e) => {
								let file = {
									...selectedParseFile
								};
								file[columnName] = e[0];
								stateSetter([
									{
										state: 'selectedParseFile',
										value: file
									}
								]);
								setValue(columnName, e[0]);
							}} style={{
								width: "100%",
								height: "200px",
								border: "1px solid #e1e1e1",
								borderRadius: "0px",
								backgroundColor: "#f5f5f5",
								...dropStyle
							}}>
								<img src={picture} style={stylePicture} />
							</Dropzone>
						</Col>
					</Col>
				);
			default:
				return ''
		}
	}

	const deleteMsg = (
		<Col md={12}>
			<h5>ARE YOU SURE YOU WANT TO DELETE&nbsp;{!schema.deleteColumn || !selectedData.get(schema.deleteColumn)
				? 'THIS DATA'
				: (
					<b>
						<span style={{
							color: 'red'
						}}>{selectedData.get(schema.deleteColumn).toUpperCase()}</span>
					</b>
				)}
				&nbsp;?</h5>
		</Col>
	)

	return (
		<Row>
			{formType.toUpperCase() !== 'DELETE'
				? (schema.columns.length == 0
					? ''
					: schema.columns.map(generateFormType))
				: deleteMsg}
		</Row>
	)
}

export default CRUDForm;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Form/_form.js